import { useEffect, useState } from "react";
import BasicTable from "../../components/common/BasicTable";
import CardLayout from "../../components/common/CardLayout";
import TitleCardSimple from "../../components/common/TitleCardSimple";
import apiEquipamentos from "../../services/apis/apiEquipamentos";
import StatusOnOff from "../../components/common/StatusOnOff";
import Table from "../../components/common/table";
import { formatFloatToPTBR } from "../../lib/utils/utils";

export default function Equipamentos() {
  const [data, setData] = useState();

  useEffect(() => {
    (async () => {
      const res = await apiEquipamentos.getEquipamentosStatus();
      setData(res.data);
    })();
  }, []);

  return (
    <div className="w-full flex flex-col justify-center items-center gap-10 pt-20">
      <div className="w-3/4 ">
        <CardLayout>
          <TitleCardSimple className="text-center">
            Bombas de Vácuo
          </TitleCardSimple>
          <BasicTable headerContent={["Nome", "Corrente", "Status"]}>
            {data?.bombasVacuo?.map((bomba, i) => (
              <Table.Row key={i}>
                <Table.Data>{bomba.nome}</Table.Data>
                <Table.Data>{formatFloatToPTBR(bomba?.leitura?.corrente) ?? 0}</Table.Data>
                <Table.Data className="flex justify-center items-center">
                  <StatusOnOff status={bomba?.leitura?.ligado ?? false} />
                </Table.Data>
              </Table.Row>
            ))}
          </BasicTable>
        </CardLayout>
      </div>

      <div className="w-3/4">
        <CardLayout>
          <TitleCardSimple className="text-center">
            Máquinas de Gelo
          </TitleCardSimple>
          <BasicTable headerContent={["Nome", "Regime", "Status"]}>
            {data?.maquinasGelo?.map((bomba, i) => (
              <Table.Row key={i}>
                <Table.Data>{bomba.nome}</Table.Data>
                <Table.Data>{bomba.regimeNome}</Table.Data>
                <Table.Data className="flex justify-center items-center">
                  <StatusOnOff status={bomba?.leitura?.ligado ?? false} />
                </Table.Data>
              </Table.Row>
            ))}
          </BasicTable>
        </CardLayout>

      </div>
        <div className="w-3/4">
        <CardLayout>
          <TitleCardSimple className="text-center">
            Ar Comprimido
          </TitleCardSimple>
          <BasicTable headerContent={["Nome", "Pressão"]}>
            {data?.arComprimido?.map((ac, i) => (
              <Table.Row key={i}>
                <Table.Data>{ac.nome}</Table.Data>
                <Table.Data>{formatFloatToPTBR(ac?.leitura?.pressao) ?? 0}</Table.Data>
              </Table.Row>
            ))}
          </BasicTable>
        </CardLayout>
      </div>
    </div>
  );
}
